import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

const NULL_GUID = '00000000-0000-0000-0000-000000000000';
const UNITED_STATES_COUNTRY_ID = 'D94A0819-59A2-443F-BC99-1EE360057F38';

// The temp living state pickers offer only the active US states, in alphabetical order.
export const getUsStateOptions = provinces => {
  const states = (Array.isArray(provinces) ? provinces : [])
    .filter(s => s.isActive === true && isIdEqual(s.countryId, UNITED_STATES_COUNTRY_ID))
    .sort((a, b) => (a.title ?? '').localeCompare(b.title ?? ''));

  return states.length > 0 ? states : [{ id: NULL_GUID, title: '' }];
};
